<template>
  <div class="app-shell">
    <div class="app-shell__aurora"></div>
    <router-view v-slot="{ Component }">
      <transition name="route-fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script>
import { apiService } from '@/common/api.services'

const ORGANIZER_TOKEN_KEY = 'organizer_access_token'
const ORGANIZER_REFRESH_KEY = 'organizer_refresh_token'
const ORGANIZER_EMAIL_KEY = 'organizer_access_email'

export default {
  name: 'App',

  mounted() {
    require('@/assets/js/theme.js')
  },

  methods: {
    clearOrganizerAccess() {
      window.localStorage.removeItem(ORGANIZER_TOKEN_KEY)
      window.localStorage.removeItem(ORGANIZER_REFRESH_KEY)
      window.localStorage.removeItem(ORGANIZER_EMAIL_KEY)
      window.localStorage.removeItem('id')
      window.localStorage.removeItem('username')
      window.localStorage.removeItem('is_allowed')
      window.localStorage.removeItem('is_superuser')
      window.localStorage.removeItem('is_student')
      window.localStorage.removeItem('is_staff')
      window.localStorage.removeItem('is_operator')
      window.localStorage.removeItem('is_cashier')
      window.localStorage.removeItem('is_admin')
    },

    applyStoredTheme() {
      document.body.dataset.theme = 'noir'
      window.localStorage.setItem('visual_theme', 'noir')
    },

    setUserInfo() {
      const endpoint = '/api/user/'
      this.error = ''

      apiService(endpoint).then((data) => {
        if (!data || !data.id) {
          if (window.localStorage.getItem(ORGANIZER_TOKEN_KEY)) {
            this.clearOrganizerAccess()
          }
          return
        }

        const requestUser = data.id
        const requestName = data.first_name
        const requestLastName = data.last_name
        const complete = `${requestName} ${requestLastName}`.trim()
        const isAdmin = data.is_admin
        const isSuperUser = data.is_superuser
        const isHost = data.is_promoter
        const isStaff = data.is_host
        const isStaffMember = data.is_staff
        const isLail = data.is_lail
        const isStudent = data.is_student
        const isOperator = data.is_operator
        const isCompany = data.is_company

        if (isAdmin === true || isSuperUser === true || isStaff === true || isLail === true || isHost === true) {
          window.localStorage.setItem('is_allowed', true)
        } else {
          window.localStorage.setItem('is_allowed', false)
        }

        window.localStorage.setItem('id', requestUser)
        window.localStorage.setItem('username', complete)
        window.localStorage.setItem('is_superuser', isSuperUser)
        window.localStorage.setItem('is_student', isStudent)
        window.localStorage.setItem('is_staff', isStaff)

        if (isStudent && data.contact_profile) {
          window.localStorage.setItem('is_special_case', data.contact_profile.is_special_case)
          window.localStorage.setItem('is_active_student', data.contact_profile.is_active_student)
        }

        window.localStorage.setItem('is_operator', isOperator || isOperator === 'true')
        window.localStorage.setItem('is_admin', isAdmin || isAdmin === 'true')
        window.localStorage.setItem('is_staff', isStaffMember || isStaffMember === 'true')

        if (isCompany || isCompany === 'true') {
          const companyData = data.user_allowed_company && data.user_allowed_company.length ? data.user_allowed_company[0] : null

          if (companyData) {
            window.localStorage.setItem('username', companyData.company_data)
            window.localStorage.setItem('company_id', companyData.company)
            window.localStorage.setItem('is_active_company', companyData.is_active_company)
          }

          window.localStorage.setItem('is_company', true)
        } else {
          window.localStorage.setItem('is_company', false)
        }
      })
    },
  },

  created() {
    this.applyStoredTheme()
    this.setUserInfo()
  },
}
</script>

<style>
#app {
  min-height: 100vh;
}

* {
  margin: 0;
  padding: 0;
  outline: 0;
  box-sizing: border-box;
}
</style>
